<template>
  <div>
    <h1 class="onboarding__title mb-5">
      Infelizmente ainda não atuamos na sua região
    </h1>
    <p class="mb-15">
      Entre em contato conosco pelo telefone
      <a
        href="https://api.whatsapp.com/send?phone=5548991610680"
        rel="noopener noreferrer"
        target="_blank"
      >
        +55 (48) 9 9161-0680
      </a>
      ou pelo email
      <a href="mailto:comercial@hauseful.com">comercial@hauseful.com</a> para
      saber mais sobre os serviços no local escolhido.
    </p>
    <p>
      <v-btn
        @click="setOnboardingStepsNavigation(1)"
        color="primary"
        elevation="0"
        large
      >
        <v-icon small left> mdi-chevron-left </v-icon>
        {{ $t('onboarding.actions.chooseAnotherCity') }}
      </v-btn>
    </p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'OnboardingStepsCityNotAvailable',

  methods: {
    ...mapMutations(['setOnboardingStepsNavigation']),
  },
}
</script>
